import { useCheckCrops } from "hooks/useCheckCrops";

export function useCheckCropsPage() {
    const { isLoading: isCheckingCrops, data: checkCropsData, mutate: checkCrops, isSuccess: hasCheckedCrops, isError: failedCheckingCrops } = useCheckCrops();

    return {
        isCheckingCrops,
        checkCropsData,
        checkCrops,
        hasCheckedCrops,
        failedCheckingCrops,
    }
}